import { ClipboardPlusIcon } from './ClipboardPlusIcon';

/**
 * author: Austin Andrews
 * id A5AA9DEA-AAAE-4C79-965F-6828F823E2CD
 * name clipboard-plus
 * version: 1.9.32
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/clipboard-plus.svg
 * tags
 */
export const ClipboardAddIcon = ClipboardPlusIcon;
export default ClipboardAddIcon